import * as React from "react";
import { Button } from "semantic-ui-react";
import { connect } from "react-redux";

import { CaseType } from "@teamprevent/common/model";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { OhCase } from "../../crud/ohCase";
import { ApplicationState } from "../../applicationState";
import { ohCaseSelector } from "../../crud/ohCase/selectors";

const ViewImmunisationCaseButtonUnconnected: React.FunctionComponent<{ task: TaskModel; ohCase: OhCase }> = (props) => {
    const linkedImmsCase = props.ohCase.linkedOhCases?.find(c => c.caseType === CaseType.IMMUNISATION);
    if (linkedImmsCase === undefined) {
        return null;
    }
    const linkUrl = `/customers/${props.task.customer.id}/employeeRecords/${props.task.employeeRecord.id}/ohCases/${linkedImmsCase.id}`;
    return (
        <a href={linkUrl}><Button content="View Immunisation Case" floated="right" /></a>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    ohCase: ohCaseSelector(state)
});

const ViewImmunisationCaseButton = connect(mapStateToProps)(ViewImmunisationCaseButtonUnconnected);

export { ViewImmunisationCaseButton };
